export var SEGMENT_API_HOST = 'cdn.dreamdata.cloud/api/v1';
//# sourceMappingURL=index.js.map